export default __webpack_public_path__ + "static/ParkingManagement-2da82203cdae266352f4474cf6a80b05.jpg";